import { Box, Grid, Card, CardActionArea, CardMedia, CardContent, Typography, AvatarGroup, Avatar } from '@mui/material';
import React from 'react';
import CommunityImg from '../../../../Assets/communityImg.png';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import routes from '../../../../Utils/routes';
import { useNavigate } from 'react-router-dom';

const CommunityCard = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`${routes.discoverGroups}/Entrepreneurs-of-Ken42`);
  };
  const data = [
    {
      title: 'Entrepreneurs of Ken42',
      subTitle: '1.2k members',
    },
    {
      title: '5K Runners Group',
      subTitle: '1.2k members',
    },
    {
      title: 'Batch 2019',
      subTitle: '1.2k members',
    },
  ];
  return (
    <div>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          {data.map((val: any) => {
            return (
              <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                <Card sx={{ width: '100%', borderRadius: 3, boxShadow: 'none !important', backgroundColor: '#F6F8FB' }} onClick={handleClick}>
                  <CardActionArea>
                    <CardMedia component="img" height="150" image={CommunityImg} alt="green iguana" />
                    <CardContent>
                      <Typography style={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>{val.title}</Typography>
                      <Typography variant="body2" color="text.secondary" style={{ textAlign: 'left', fontSize: '10.5px', fontWeight: 400 }}>
                        {val.subTitle}
                      </Typography>
                      <Box sx={{ display: 'flex', justifyContent: 'start', mt: 0.3 }}>
                        <AvatarGroup max={4}>
                          <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" sx={{ width: 20, height: 20 }} />
                          <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" sx={{ width: 20, height: 20 }} />
                          <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" sx={{ width: 20, height: 20 }} />
                          <Avatar alt="Agnes Walker" src="/static/images/avatar/4.jpg" sx={{ width: 20, height: 20 }} />
                        </AvatarGroup>
                        <Typography sx={{ m: 0.4, fontSize: '9px', fontWeight: 400 }}>Sajin and 24 friends are members</Typography>
                      </Box>
                      <Grid container spacing={2} sx={{ mt: 0.1 }}>
                        <Grid item xs={9} sm={9} md={9} lg={6} xl={6}>
                          <Typography style={{ textAlign: 'start', fontSize: '10.5px', fontWeight: 500 }}>Group settings</Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={6} xl={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                          <ArrowForwardIcon style={{ fontSize: '15px' }} />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </div>
  );
};

export default CommunityCard;
